import React from 'react'
import './explanation.scss'

import arrow from '../../../../assets/arrow_icon_left.png'

function Explanation({ type, imguri, title, subtitle }) {

  const explanationImg = type == 'right' ?
    [
      <img className={`explanation_arrow pc_arrow explanation_arrow_${type}`} src={arrow} />,
      <img src={imguri}></img>
    ] :
    [
      <img src={imguri}></img>,
      <img className={`explanation_arrow pc_arrow explanation_arrow_${type}`} src={arrow} />
    ]
  const explanationText =
    <div className={`explanation_text_container  explanation_text_container_${type}`}>
      <img className={`mobile_arrow explanation_arrow explanation_arrow_${type}`} src={arrow} />
      <p className="explanation_title">{title}</p>
      <p className="explanation_subtitle">{subtitle}</p>
    </div>

  const mobile_content = type == 'right' ?
    <div className="mobile_left">{[explanationImg, explanationText]}</div> :
    <div className="mobile_right">{[explanationText, explanationImg]}</div>

  return [<div className={`explanation_pc_container explanation explanation-${type}`}>
    {explanationImg}
    {explanationText}
  </div>, <div className={'explanation_mobile_container'}>
    {mobile_content}
  </div>]
}

export default Explanation